import { render, staticRenderFns } from "./OrderUnconfirmed.vue?vue&type=template&id=b8387ae4&"
import script from "./OrderUnconfirmed.vue?vue&type=script&lang=ts&"
export * from "./OrderUnconfirmed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports